import React from "react";
import PropTypes from "prop-types";
import generateID from "../../../utils/string-utils";
var ConsentAdditionalDetails = function (props) {
    var additionalDetailsLabel = props.additionalDetailsLabel, id = props.id, children = props.children;
    var _id = id || generateID();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "fr-consent-service__collapse" },
            React.createElement("button", { className: "fr-consent-service__collapse-btn", "aria-expanded": "false", "aria-describedby": "finality-".concat(_id, "-legend"), "aria-controls": "finality-".concat(_id, "-collapse") },
                " ",
                additionalDetailsLabel)),
        React.createElement("div", { className: "fr-consent-services fr-collapse", id: "finality-".concat(_id, "-collapse") }, children)));
};
ConsentAdditionalDetails.defaultProps = { __TYPE: "ConsentAdditionalDetails" };
ConsentAdditionalDetails.propTypes = { __TYPE: PropTypes.any };
export default ConsentAdditionalDetails;
